var map = {
	"./reflection/lucky/key.png": 94329,
	"./reflection/lucky/light1.png": 90091,
	"./reflection/lucky/light2.png": 24688,
	"./reflection/lucky/lucky-btn-bg.png": 5231,
	"./reflection/lucky/lucky-item-bg.png": 58908,
	"./reflection/lucky/lucky-result-coin-tapcoins.png": 87356,
	"./reflection/lucky/lucky-result-coin-ton.png": 39164,
	"./reflection/lucky/lucky-result-coin-usdt.png": 14063,
	"./reflection/lucky/lucky-result-light.png": 46319,
	"./reflection/lucky/tapcoins.png": 94645,
	"./reflection/lucky/ton.png": 43223,
	"./reflection/lucky/usdt.png": 4622
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80434;